// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"PreviewPlayer_videoContainer__1WDep","img":"PreviewPlayer_img__cnOGJ","video":"PreviewPlayer_video__3hzUw","loading":"PreviewPlayer_loading__20TsF"};